import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import BreadcrumbComponent from "@/components/BreadcrumbComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: '_adminTemplateView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.name != 'dashboard')
      ? (_openBlock(), _createBlock(BreadcrumbComponent, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}
}

})